import { validateUrls } from "api/types"

export const urls = validateUrls({
  retrieveSubmission: submissionId =>
    `/assignments/submissions/${submissionId}/`,
  attachment: attachmentId =>
    `/assignments/submissions/attachments/${attachmentId}/`,
})
